import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showQuotaExceededModal, showAccessDenied } from 'store/actions/globalActions';
import { getVideoPermissions, setVideoDownloading, userHasRemainingQuota, videoDownloaded } from 'store/actions/videos';
import Loading from 'elements/common/loading/Loading';
import { VIDEO_RENDITIONS } from '../../../utils/constants';

class VideoDownloadOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      videoPermissionsLoading: false,
      videoPermissions: { permissions: {}, renditions: {} },
    };
  }

  toggleOpen() {
    this.setState(({ open }) => ({ open: !open }));
  }

  fetchPermissions() {
    const { id } = this.props;
    this.props.userHasRemainingQuota();
    return this.props.getVideoPermissions(id);
  }

  async getVideoPermissions() {
    const { open } = this.state;
    this.setState({ videoPermissionsLoading: true });
    this.toggleOpen();

    if (!open) {
      this.setState({ videoPermissions: await this.fetchPermissions() });
    }
    this.setState({ videoPermissionsLoading: false });
  }

  downloadVideo(event, url) {
    const { id, hasRemainingQuota } = this.props;
    const { videoPermissions: { permissions } } = this.state;

    if (!hasRemainingQuota || !(permissions && permissions.download && url)) {
      event.stopPropagation();
      event.preventDefault();
      return (!hasRemainingQuota) ? this.props.showQuotaExceededModal() : this.props.showAccessDenied();
    }

    this.props.setVideoDownloading();
    this.props.videoDownloaded(id, url);
  }

  render() {
    const { className, label = 'Download' } = this.props;
    const { open, videoPermissions, videoPermissionsLoading } = this.state;
    const renditions = (videoPermissions && videoPermissions.renditions) || {};
    return (
      <span className={`story-download ${className} ${open ? 'open' : 'close'} video-designator`}>
        <button className="button--download" onClick={() => this.getVideoPermissions()}>{ label }</button>
        <div className="story-download-options">
          { videoPermissionsLoading ? <a className="story-download-options-button"><Loading /></a> : (
            <React.Fragment>
              {renditions.watermark && <a className="story-download-options-button" target="_blank" rel="noopener noreferrer" href={renditions.watermark} onClick={ e => this.downloadVideo(e, renditions.watermark) } download>{VIDEO_RENDITIONS.lowres.encoding}</a>
              || <span className="story-download-options-button-inactive">{VIDEO_RENDITIONS.lowres.encoding}</span>}
              {renditions.compressed && <a className="story-download-options-button" target="_blank" rel="noopener noreferrer" href={renditions.compressed} onClick={ e => this.downloadVideo(e, renditions.compressed) } download>{VIDEO_RENDITIONS.compressed.encoding}</a>
              || <span className="story-download-options-button-inactive">{VIDEO_RENDITIONS.compressed.encoding}</span>}
              {renditions.highres && <a className="story-download-options-button" target="_blank" rel="noopener noreferrer" href={renditions.highres} onClick={ e => this.downloadVideo(e, renditions.highres) } download>{VIDEO_RENDITIONS.highres.encoding}</a>
              || <span className="story-download-options-button-inactive">{VIDEO_RENDITIONS.highres.encoding}</span>}
            </React.Fragment>)
          }
        </div>
      </span>
    );
  }
}

const mapStateToProps = ({ videos: { hasRemainingQuota } }) => ({
  hasRemainingQuota,
});

const mapDispatchToProps = {
  setVideoDownloading,
  getVideoPermissions,
  videoDownloaded,
  userHasRemainingQuota,
  showQuotaExceededModal,
  showAccessDenied,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoDownloadOptions);
